export const MOCK_TEMPLATES = [
  {
    id: "tpl-1",
    category: "EMPLOYMENT",
    title: "Employment Contract — Standard",
    description: "Full-time employee agreement with benefits schedule and termination provisions.",
    clauses: 10,
    updatedDaysAgo: 2,
    status: "Approved",
    usedCount: 88,
    adoption: 88,
  },
  {
    id: "tpl-2",
    category: "COMMERCIAL",
    title: "Service Level Agreement",
    description: "SLA framework with KPIs, penalty clauses and measurement schedules.",
    clauses: 12,
    updatedDaysAgo: 4,
    status: "Approved",
    usedCount: 67,
    adoption: 67,
  },
  {
    id: "tpl-3",
    category: "COMMERCIAL",
    title: "Consulting Agreement",
    description: "Professional consulting with deliverables, IP transfer and confidentiality.",
    clauses: 9,
    updatedDaysAgo: 1,
    status: "Approved",
    usedCount: 61,
    adoption: 61,
  },
  {
    id: "tpl-4",
    category: "EMPLOYMENT",
    title: "Freelance Services Agreement",
    description: "Independent contractor agreement for project-based engagements.",
    clauses: 10,
    updatedDaysAgo: 1,
    status: "Approved",
    usedCount: 55,
    adoption: 55,
  },
  {
    id: "tpl-5",
    category: "CONFIDENTIALITY",
    title: "Data Processing Agreement",
    description: "GDPR-compliant DPA with SCCs, processor obligations and breach protocols.",
    clauses: 13,
    updatedDaysAgo: 3,
    status: "Approved",
    usedCount: 49,
    adoption: 49,
  },
];
